/**
 * Web 端 Pythra Forge 是否开放。
 *
 * 正式环境暂不在 Web 浏览器提供 Forge，统一引导下载 App；
 * 但 App 内 WebView、测试环境、本地开发仍保持开放，便于使用与调试。
 *
 * 放行条件（满足任一即开放）：
 *  - App 内 WebView：localStorage.__rn__ 为真（见 app.tsx 的 inlineMode 判定）
 *  - 本地开发：NODE_ENV !== 'production'
 *  - 测试环境：NEXT_PUBLIC_TEST_ENV === 'true' 或 origin 为 test 域名
 * 其余（正式环境的真实 Web 浏览器）→ 关闭。
 *
 * 注意：本函数会读取 window / localStorage，仅可在客户端挂载后调用，
 * 否则服务端与首帧客户端判定不一致会造成水合错位。
 */
export function isForgeWebEnabled(): boolean {
  if (typeof window !== 'undefined') {
    try {
      // 本地联调开关：localStorage.forgeWebOff = '1' 强制走「关闭」分支，
      // 免得每次都要 yarn build 才能验证跳转。仅用于测试，正式逻辑不依赖它。
      if ((window.localStorage as unknown as Record<string, unknown>).forgeWebOff) return false;
      // App 内 WebView：与 app.tsx 保持一致，勿误伤 App。
      if ((window.localStorage as unknown as Record<string, unknown>).__rn__) return true;
    } catch {
      // localStorage 不可用时忽略，继续走后续判定。
    }
  }

  if (process.env.NODE_ENV !== 'production') return true;
  if (process.env.NEXT_PUBLIC_TEST_ENV === 'true') return true;
  if (process.env.NEXT_PUBLIC_FORGE_WEB_ENABLED === 'true') return true;

  if (typeof window !== 'undefined' && window.location?.origin === 'https://test.alfagpt.org') {
    return true;
  }

  return false;
}
